<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de exame de imagem">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/relatorio-exame-imagem/List'

export default {
    components: {
        List,
    },
}
</script>